import React, { useState } from "react";
import Body from "./Body";

const Tuition = () => {
  const [filter, setFilter] = useState({
    gender: "all",
  });

  const [studentDetailsModal, setStudentDetailsModal] = useState(false);
  const [editScheduleModal, setEditScheduleModal] = useState(false);
  const [lineChartData, setLineChartData] = useState([
    { name: "Jan", key1: 40, key2: 20 },
    { name: "Feb", key1: 45, key2: 22 },
    { name: "Mar", key1: 50, key2: 25 },
    { name: "Apr", key1: 70, key2: 28 },
    { name: "May", key1: 70, key2: 56 },
    { name: "June", key1: 60, key2: 45 },
    { name: "July", key1: 56, key2: 23 },
    { name: "Aug", key1: 35, key2: 78 },
    { name: "Sept", key1: 29, key2: 97 },
    { name: "Oct", key1: 59, key2: 34 },
    { name: "Nov", key1: 14, key2: 76 },
  ]);
  const [classesFilter, setClassesFilter] = useState([]);
  const [editModalShiftChange, setEditModalShiftChange] = useState(false);
  const [changeTuitionPage, setChangeTuitionPage] = useState(false);
  const [changeTuitionPageName, setChangeTuitionPageName] = useState("Tuition");
  const _this = {
    filter,
    setFilter,
    classesFilter,
    lineChartData,
    setLineChartData,
    setClassesFilter,
    editScheduleModal,
    studentDetailsModal,
    setStudentDetailsModal,
    setEditScheduleModal,
    editModalShiftChange,
    setEditModalShiftChange,
    changeTuitionPage,
    setChangeTuitionPage,
    changeTuitionPageName,
    setChangeTuitionPageName,
  };

  return <Body {..._this} />;
};

export default Tuition;
